import styled from 'styled-components';

interface Props {
  $isError: boolean;
}

export const StateCityNeightbornContent = styled.form`
  display: grid;
  gap: 12px;
  align-items: end;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    grid-template-columns: auto auto minmax(0, 1fr) auto;

    .form-group-neighborhood {
      min-width: 0;
      box-sizing: border-box;
    }

    .search-agendas-wrap {
      justify-self: start;
    }
  }

  @media (max-width: 1023px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    align-items: stretch;

    .form-group,
    .form-group-neighborhood,
    .search-agendas-wrap {
      min-width: 0;
      box-sizing: border-box;
    }

    .search-agendas-wrap .search-button {
      width: 100%;
      max-width: 100%;
    }
  }

  .form-group:not(:last-of-type) {
    margin-right: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
  }

  /* Linha “rótulo + ajuda (i)” — evita margin do label global empurrar o ícone */
  .label-inline-row label {
    margin-bottom: 0;
  }

  button.search-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 42px;
    border: 1px solid var(--ins-blue);
    border-radius: 8px;
    background-color: transparent;
    margin-left: 0;
    color: var(--ins-blue);
    font-weight: 700;
    font-size: inherit;
    font-family: inherit;
    transition: 0.3s;
    box-sizing: border-box;

    svg {
      margin-right: 8px;
    }

    &:hover:not(:disabled) {
      background-color: var(--ins-blue);
      color: var(--white);

      svg path {
        fill: var(--white);
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    @media (max-width: 1023px) {
      width: 100%;
      max-width: 100%;
    }
  }
`;

/** Tooltip acima do botão “Buscar agendas” quando desabilitado (hover no wrapper). */
export const SearchButtonTooltip = styled.span`
  position: absolute;
  z-index: 30;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%);
  width: min(280px, calc(100vw - 48px));
  padding: 10px 12px;
  border-radius: 6px;
  background: var(--gray-900);
  color: var(--white);
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 1.45;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.15s ease,
    visibility 0.15s ease;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -6px;
    border: 6px solid transparent;
    border-top-color: var(--gray-900);
  }
`;

export const SearchButtonHoverWrap = styled.span`
  position: relative;
  display: inline-flex;
  vertical-align: bottom;

  &:hover ${SearchButtonTooltip} {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

export const Select = styled.select<Props>`
  width: 225px;
  max-width: 100%;
  height: 42px;
  border: ${({ $isError }) =>
    $isError ? '1px solid var(--feedback-negative)' : '1px solid var(--gray-400)'};
  border-radius: 4px;
  box-sizing: border-box;
  font: inherit;
  color: var(--gray-900);

  &:has(option:checked[value='']) {
    color: var(--gray-500);
  }

  option[value=''] {
    color: var(--gray-500);
  }

  &:disabled {
    cursor: not-allowed;
    background-color: var(--gray-100);
    color: var(--gray-500);
    -webkit-text-fill-color: var(--gray-500);
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;
